import { BasePill } from "./BasePill";
import { PillProps } from "./types";

export const SecondaryPill = ({
  children,
  variant = "DEFAULT",
  ...props
}: PillProps) => {
  return (
    <BasePill {...props} type="SECONDARY" variant={variant}>
      {children}
    </BasePill>
  );
};
